import { render, staticRenderFns } from "./PPublicIconWithSpeechBalloonModal.vue?vue&type=template&id=1222c5ee&scoped=true&"
import script from "./PPublicIconWithSpeechBalloonModal.vue?vue&type=script&lang=ts&"
export * from "./PPublicIconWithSpeechBalloonModal.vue?vue&type=script&lang=ts&"
import style0 from "./PPublicIconWithSpeechBalloonModal.vue?vue&type=style&index=0&id=1222c5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1222c5ee",
  null
  
)

export default component.exports